module.exports = __webpack_public_path__ + "media/images/frontend/pages/processes-2-d0dde3c4622926d7cd07ebca5418a739.jpg";